import { useLocation } from 'react-router-dom';
import { useCookies } from 'react-cookie';
// @mui
import { styled } from '@mui/material/styles';
import { Card, Container, Typography } from '@mui/material';
// hooks
import useResponsive from 'src/hooks/use-responsive';
import usePush from 'src/hooks/use-push';
// components
import Page from 'src/components/molecules/page';
import Logo from 'src/components/molecules/logo';
// sections
import LoginForm from 'src/components/molecules/login-form';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  padding: theme.spacing(3),
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    padding: theme.spacing(7, 5, 0, 7),
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Login() {
  const [cookies, setCookie, removeCookie] = useCookies(['loginEmail']);
  const location = useLocation();
  const { pathname } = useLocation();
  const mdUp = useResponsive('up', 'md', null, null);
  const push = usePush();

  const defaultValues = {
    email: cookies.loginEmail ?? '',
    password: '',
    remember: true,
  };

  const LoginOnSubmit = (formValue: any) =>
    new Promise((resolve) => {
      if (formValue.remember) {
        setCookie('loginEmail', formValue.email);
      } else {
        removeCookie('loginEmail');
      }
      push(resolve, {
        reqProp: {
          pathKey: pathname.split('/')[1] !== 'marriageAgencyStaff' ? 'signIn' : 'signInForMarriageAgencyStaff',
          method: 'post',
          data: { email: formValue.email, password: formValue.password },
        },
        aftProp: {
          resolve,
          nextPath: '/login/twoFactorAuth',
          showMessage: {
            state: {
              snackBar: { open: true, viewType: 'success', message: 'メールをお送りしました' },
              ...(location.state && (location as any).state.from ? { loginFrom: (location as any).state.from } : false),
            },
          },
        },
      });
    });

  return (
    <Page title="Login">
      <RootStyle>
        <HeaderStyle>{mdUp && <Logo />}</HeaderStyle>

        {mdUp && (
          <SectionStyle>
            <img src="/static/illustrations/illustration_login.svg" alt="login" />
          </SectionStyle>
        )}

        <Container maxWidth="sm">
          <ContentStyle>
            <Typography variant="h4" gutterBottom>
              サインイン
            </Typography>

            <Typography sx={{ color: 'text.secondary', mb: 5 }} />

            <LoginForm defaultValues={defaultValues} LoginOnSubmit={() => LoginOnSubmit} />
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
